import React, { useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import ConversionLogs from './ConversionLogs';
import AdminLayout from '../../components/Layout';
import SitesStats from './SitesStats';
import AdsStats from './AdsStats';
import CountryStats from './CountryStats';

// Компонент для содержимого таба
function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`stats-tabpanel-${index}`}
            aria-labelledby={`stats-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `stats-tab-${index}`,
        'aria-controls': `stats-tabpanel-${index}`,
    };
}

const StatsPage = () => {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <AdminLayout>
            <Typography variant="h4" component="h1" className="mb-6">
                Статистика
            </Typography>

            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs 
                    value={tabValue} 
                    onChange={handleTabChange} 
                    aria-label="statistics tabs"
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab label="Логи конверсий" {...a11yProps(0)} />
                    <Tab label="Статистика по сайтам" {...a11yProps(1)} />
                    <Tab label="Статистика по объявлениям" {...a11yProps(2)} />
                    <Tab label="Статистика по странам" {...a11yProps(3)} />
                </Tabs>
            </Box>

            <TabPanel value={tabValue} index={0}>
                <ConversionLogs />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
                <SitesStats />
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
                <AdsStats />
            </TabPanel>
            <TabPanel value={tabValue} index={3}>
                <CountryStats />
            </TabPanel>
        </AdminLayout>
    );
};

export default StatsPage; 